import FilterIntegrationCard from './FilterIntegrationCard';

export default FilterIntegrationCard;
